import React from 'react'
import s from './empty-note.module.scss'
import { queryClient } from '@shared/api/query-client'
import { Button } from '@shared/ui/button/button'

export const EmptyNote = ({onClick}) => {
	const {data: profile} = queryClient.getQueryData(['profile'])
	const isTeacher = profile?.role === 'teacher'

	return (
		<div className={s.wrapper}>
			<img src={process.env.REACT_APP_STORAGE_URL + "images/draw-icons/empty-attachments.png"} alt='' className={s.img}/>
			<p className={s.description}>{isTeacher ? 'Вы пока не прикрепили материалы к занятию' : 'Учитель пока не прикрепил материалы к занятию'}</p>
			<Button size="small" className={s.button} label="Добавить блок" onClick={onClick}/>
		</div>
	)
}
